import type { FC, ReactNode } from "react";

import { type IconName, SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

type ChartTooltipType = Extract<IconName, "info">;

interface ChartTooltipFootnoteProps {
    type?: ChartTooltipType;
    children: ReactNode;
}

export const ChartTooltipFootnote: FC<ChartTooltipFootnoteProps> = ({ children, type = "info" }) => {
    return (
        <Flex
            alignItems="center"
            gap="8px"
            padding="8px"
            borderRadius="8px"
            background={colorsPalettes.carbon[25]}
        >
            <SWReactIcons
                size="xs"
                iconName={type}
                iconColor={colorsPalettes.carbon[200]}
            />
            <Text fontVariant="caption">{children}</Text>
        </Flex>
    );
};
